import styled from 'styled-components';
import { customMedia, cssDropdown, cssDropdownItem } from 'styles/utils';
import { themes } from 'styles/themes/wikifactoryNew';

import Icon from '../Icon';

export const DropdownStyled = styled.div`
  position: relative;
  display: inline-block;
  font-size: ${props => themes.font.size[props.size]};
`;

export const IconStyled = styled(Icon)`
  margin-right: ${props => props.theme.spacing.small};
  vertical-align: top;
`;

export const DropTrigger = styled.button(
  ({ theme, variant, borderRadius, hoverStyle }) => {
    let styleSheet = {
      '-webkit-appearance': 'none',
      display: 'flex',
      cursor: 'pointer',
      padding: `${theme.spacing.small} ${theme.spacing.default}`,
      borderRadius: borderRadius || theme.borderRadius.large,
      border: 'none',
      backgroundColor: 'transparent',
      color: theme.color.wfBlack,
      transition: `background-color linear 0.2s`,
      '&:hover': hoverStyle || {
        backgroundColor: theme.color.wfGrey200,
      },
    };

    if (variant.includes('outlined')) {
      styleSheet = {
        ...styleSheet,
        border: `1px solid ${theme.color.wfGrey500}`,
        borderRadius: 0,
      };
    }
    if (variant.includes('fullWidth')) {
      styleSheet = {
        ...styleSheet,
        width: '100%',
      };
    }

    return styleSheet;
  },
);

export const Placeholder = styled.span`
  color: ${props => props.theme.color.wfBlack};
  font-weight: ${props =>
    props.boldSelectedItem && props.theme.font.weight.xbold};
`;

const GAP = 8;

export const DropMenu = styled.ul`
  display: inline-block;
  right: 1px;
  top: ${({ placement }) => (placement === 'bottom' ? '100%' : 'auto')};
  bottom: ${({ placement }) =>
    placement === 'top' ? `calc(100% + ${GAP}px)` : 'auto'};
  ${cssDropdown};
  min-width: ${props => (props.autoWidth ? 'auto' : cssDropdown.minWidth)};
  ${customMedia.lessThan('medium')`
    left: 0;
  `};
  width: ${props => props.variant.includes('fullWidth') && 'calc(100% - 2px)'};
`;

export const DropItem = styled.li`
  display: flex;
  align-items: center;
  ${cssDropdownItem}
`;
